import { Component, OnInit, Inject } from '@angular/core';
import { EstadoPedido } from '../../pedido/estado-pedido.model';
import { Pedido } from '../../pedido/pedido.model';
import { Environment } from '../../../environments/enviroment.model';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvironmentProvider } from '../../core/browser-providers';
import { BackendService } from '../../core/backend.service';
import { MatPaginatorIntl, MatIconRegistry } from '@angular/material';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { SecurityService } from '../../security/security.service';
import { EstadoAcuerdo } from '../estado-acuerdo.model';
import { Acuerdo } from '../acuerdo.model';
import { SnackService } from '../../shared-services/snack.service';
import { ArchivoService } from '../../core/archivo.service';
import { Http } from '@angular/http';
import { Observer } from '../../../../node_modules/rxjs/Observer';
import { Observable } from '../../../../node_modules/rxjs/Observable';


interface Filters {
  page: number;
  size: number;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-ver-pedidos',
  templateUrl: './ver-pedidos.component.html',
  styleUrls: ['./ver-pedidos.component.scss']
})
export class VerPedidosComponent implements OnInit {

  acuerdo: Acuerdo;
  isLoading: boolean;
  totalItems: number;
  public EstadoPedido = new EstadoPedido();


  private filters: Filters = {
    page: 0,
    size: 10,
  };

  pedidosList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const usersPromise = this.backendService.get(Pedido, Pedido.path + 'allByAcuerdo/' + this.acuerdo.id, null).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const permissions = await usersPromise;
        return permissions;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
      }
    })();
  }).share() as Observer<Filters> & Observable<Pedido[]>;


  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    public securityService: SecurityService,
    private matIconRegistry: MatIconRegistry,
    private _http: Http,
    private archivoService: ArchivoService,
    private snackService: SnackService,
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.acuerdo = data.acuerdo;
    });

    this.pedidosList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refresList();
  }

  refresList() {
    this.pedidosList.next(this.getFilters());
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
  }

  getFilters() {
    return this.filters;
  }

  detallesPedido(id: number) {
    this.router.navigate(['/pedidos/detalles/', id]);
  }

  back() {
    this.router.navigate(['/clientes/ver-acuerdos/' + this.acuerdo.cliente.id]);
  }

  async pdf(id: number) {
    this.snackService.spinner(true);
    try {
      await this.archivoService.getArchivo(id).subscribe(data => {
        this.openWindow(data);
        this.removeFile(id);
      });
    } catch (ex) {
      if (ex[0]) {
        this.snackService.error(ex[0].details);
      } else if (ex.errors) {
        this.snackService.error(ex.errors[0].defaultMessage);
      } else {
        this.snackService.error(ex.message);
      }
    } finally {
      this.snackService.spinner(false);

    }

  }

  private openWindow(data) {
    try {
      const blob = new Blob([data], { type: data.type });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    } catch (ex) {
      console.log(ex);
    }
  }

  removeFile(id: number) {
    this.backendService.delete(Pedido.path + 'eliminar-pdf/' + id);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/ver-pedidos/ver-pedidos.component.ts